import { format } from 'date-fns';
import { memo } from 'react';

import { cn } from '@/ui/lib/utils';

import type { TimeGutterProps } from './types';

function formatHourLabel(minutesOfDay: number): string {
  const reference = new Date(2000, 0, 1, 0, minutesOfDay);
  return format(reference, 'h a');
}

function TimeGutter({ minMinutes, maxMinutes, pxPerMinute }: TimeGutterProps) {
  const hourMarks: number[] = [];
  for (let minutes = Math.ceil(minMinutes / 60) * 60; minutes < maxMinutes; minutes += 60) {
    hourMarks.push(minutes);
  }

  return (
    <div
      className="relative w-14 shrink-0"
      style={{ height: (maxMinutes - minMinutes) * pxPerMinute }}>
      {hourMarks.map((minutes, index) => (
        <div
          key={minutes}
          className={cn(
            'absolute right-2 text-[11px] text-uniform-gray-500 dark:text-uniform-gray-400',
            index === 0 && 'translate-y-0',
            index === hourMarks.length - 1 && '-translate-y-full',
            index !== 0 && index !== hourMarks.length - 1 && '-translate-y-1/2'
          )}
          style={{ top: (minutes - minMinutes) * pxPerMinute }}>
          {formatHourLabel(minutes)}
        </div>
      ))}
    </div>
  );
}

export default memo(TimeGutter);
